import { render } from "./StudyGallery.vue?vue&type=template&id=2714b0df&ts=true"
import script from "./StudyGallery.vue?vue&type=script&lang=ts"
export * from "./StudyGallery.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__